module.exports = __webpack_public_path__ + "static/3DGENS_LOGO-cbb97b1c96ebcc554593c2c319d93396.png";